import { useCallback } from 'react';
import {
  createTicket,
  updateTicket,
  appendTicketMessage,
} from '../services/tickets/TicketService';

export function useTickets() {
  const create = useCallback((input: Parameters<typeof createTicket>[0]) => createTicket(input), []);
  const update = useCallback((input: Parameters<typeof updateTicket>[0]) => updateTicket(input), []);
  const append = useCallback(
    (input: Parameters<typeof appendTicketMessage>[0]) => appendTicketMessage(input),
    [],
  );
  return { createTicket: create, updateTicket: update, appendTicketMessage: append };
}
